import React from 'react'
import { ConvertedOrder } from '~/app/components/order-converter/getCartOrderConverter'
import { BUTTON_SIZE, BUTTON_TYPE } from '~/app/components'
import styled from '~/app/components/styled'
import Button from '../../common/Button/Button'
import { Typography } from '@yanolja-rnd/ya-com-core'
import {
  OrderButtonIconType,
  OrderButtonType,
  TOrderButtonIconType,
  TOrderButtonType,
} from '~/app/components/order-converter/types'
import { Icon_qr, Icon_review, Icon_ticket_new } from '@yanolja-rnd/ya-com-system-icon'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
`

const ItemButton = styled(Button)<{ isFullWidth: boolean }>`
  flex: 1 1 ${({ isFullWidth }) => (isFullWidth ? '100%' : 'calc(50% - 0.8rem)')};
`

const ButtonInner = styled.span<{ orderButtonType: TOrderButtonType }>`
  display: grid;
  align-items: center;
  justify-content: center;
  column-gap: ${({ orderButtonType: type }) =>
    type === OrderButtonType.PRIMARY ? '0.7rem' : '0.2rem'};
  ${({ orderButtonType: type }) =>
    type === OrderButtonType.PRIMARY ? Typography('body2').bold : Typography('body2').regular};
  ${({ orderButtonType: type }) =>
    type === OrderButtonType.PRIMARY && 'grid-template-columns: 1.6rem 1fr'};
  ${({ orderButtonType: type }) =>
    type === OrderButtonType.SECONDARY && 'grid-template-columns: 1.4rem 1fr'};
`
const IconReview = styled(Icon_review)`
  path {
    fill: ${({ theme }) => theme.color.blue600};
  }
`

type Props = Pick<ConvertedOrder, 'buttons'> & {
  className?: string
  onButtonClick: (id: string, data?: any) => void
  onButtonImpressed: (id: string, data?: any) => void
}

const OrderCardItemButtons = ({
  buttons = [],
  onButtonClick,
  onButtonImpressed,
  className,
}: Props) => {
  const buttonIcon = (icon: TOrderButtonIconType) => {
    switch (icon) {
      case OrderButtonIconType.QR:
        return <Icon_qr size={1.6} unit="rem" />
      case OrderButtonIconType.TICKET:
        return <Icon_ticket_new size={1.6} unit="rem" />
      case OrderButtonIconType.CHAT:
        return <IconReview size={1.4} unit="rem" />
      default:
        return null
    }
  }

  return (
    <Container className={className}>
      {buttons.map(({ title, id, isDisabled, data, type, icon }) => {
        return (
          <ItemButton
            type={type === OrderButtonType.SECONDARY ? BUTTON_TYPE.SECONDARY : BUTTON_TYPE.BASIC}
            isFullWidth={id === 'nol-chat' || id === 'review'}
            size={type === OrderButtonType.PRIMARY ? BUTTON_SIZE.M : BUTTON_SIZE.XS}
            onClick={() => onButtonClick(id, data)}
            onImpressed={() => onButtonImpressed(id, data)}
            key={id}
            isDisabled={isDisabled}
            isDisabledEventDelegation={true}
          >
            <ButtonInner orderButtonType={type}>
              {icon && buttonIcon(icon)}
              {title}
            </ButtonInner>
          </ItemButton>
        )
      })}
    </Container>
  )
}

export default OrderCardItemButtons
